"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const module_1 = require("../core/module");
class BannerModule extends module_1.default {
    constructor() {
        super(...arguments);
        this.endpoint = "/api/v2/promotional/banners/";
        this._canPaginate = false;
    }
    async list() {
        const results = (await this._list());
        return results;
    }
}
exports.default = BannerModule;
//# sourceMappingURL=banner.js.map